import {
  SearchItemHeader,
  Wrapper,
} from '@web/conversations/ConversationSearch/ConversationSearchItem/conversationSearchItem.styles';
import { AvatarSkeleton } from '@web/components/skeletonLoaders/AvatarSkeleton';
import { AuthorNameSkeleton } from '@web/conversations/ConversationSearch/components/AuthorNameSkeleton';
import { SearchContentSkeleton } from '@web/conversations/ConversationSearch/components/SearchContentSkeleton';

export const ConversationSearchSkeleton = () => {
  return (
    <Wrapper>
      <AvatarSkeleton />
      <div>
        <SearchItemHeader>
          <AuthorNameSkeleton />
        </SearchItemHeader>
        <SearchContentSkeleton />
      </div>
    </Wrapper>
  );
};
